module.exports = __webpack_public_path__ + "static/img/service.f312197.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service.svg
// module id = dW+t
// module chunks = 2